/** @format */

import React, { useState } from "react";
import { withFormik, Field } from "formik";
import WithModal from "./WithModal";
import { sendError } from "../Analytics";
import { API_BASE_API } from "../../OldApp";
import AbsoluteLoadingOverlay from "../AbsoluteLoadingOverlay";

// Formik pieces come almost directly from their examples.

const TenantReferralForm = (props) => {
  const { dirty, isSubmitting, handleSubmit, handleReset } = props;

  const Errors = ({ id, ...props }) =>
    (props.errors[id] && props.touched[id] && (
      <div className="input-feedback">{props.errors[id]}</div>
    )) ||
    null;

  const TextInput = (m) => (
    /* For some reason, calling this as <TextInput> blurs after each char, but calling as a function in {} works fine? */

    <div
      className="contactFormInput"
      key={m.id}
      style={{ flexGrow: 1, padding: "0px 8px" }}
    >
      <label htmlFor={m.id} className={m.required ? "label-required" : ""}>
        {m.label}
      </label>
      <Field type="text" name={m.id} placeholder={m.placeholder}>
        {({ field, form }) => (
          <input
            type="text"
            {...field}
            className={
              form.errors[m.id] && form.touched[m.id]
                ? "text-input error"
                : "text-input"
            }
          />
        )}
      </Field>
      <Errors id={m.id} {...props} />
    </div>
  );
  return (
    <div className="contactForm contactformtwoWrapper">
      <div className="propertyColumns">
        <div className="propertyLeftColumn">
          <div className="propertyAddressCard">
            <h1 className="propertyName" style={{ padding: "0px 8px" }}>
              Tenant Referral
            </h1>
          </div>
        </div>
      </div>
      <div className="modal-narrative">
        <h3 className="modal-narrative-tagline">
          Choose your Neighbors. Build your Referral Base. Create a Community.
        </h3>
      </div>
      {props.submissionResult && <p>{props.submissionResult}</p>}
      {!props.submissionResult && (
        <form className="tenantReferralFormForm" onSubmit={handleSubmit}>
          <div>
            {[
              {
                id: "name",
                required: true,
                placeholder: "Name",
                label: "Your Name",
              },
              {
                id: "company_name",
                required: false,
                placeholder: "Company",
                label: "Your Company Name",
              },
            ].map(TextInput)}
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {[
              {
                id: "company_address",
                required: false,
                placeholder: "Company Address",
                label: "Your Company Address",
              },
            ].map(TextInput)}
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {[
              {
                id: "referral_contact_name",
                required: true,
                placeholder: "Referral Contact Name",
                label: "Referral Contact Name",
              },
              {
                id: "referral_company_name",
                required: false,
                placeholder: "Referral Company Name",
                label: "Referral Company Name",
              },
            ].map(TextInput)}
          </div>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {[
              {
                id: "referral_contact_phone",
                required: true,
                placeholder: "Referral Contact Phone",
                label: "Referral Contact Phone",
                column: "col-lg-6",
              },
              {
                id: "referral_contact_email",
                required: true,
                placeholder: "Referral Contact Email",
                label: "Referral Contact Email",
                column: "col-lg-6",
              },
            ].map(TextInput)}
          </div>

          <div className="contactFormInput" style={{ padding: "0px 8px" }}>
            <label htmlFor="comments">Comments</label>
            <Field
              type="text"
              name="comments"
              placeholder="Any additional comments"
            >
              {({ field, form }) => (
                <textarea
                  {...field}
                  className={
                    form.errors["comments"] && form.touched["comments"]
                      ? "text-input error"
                      : "text-input"
                  }
                />
              )}
            </Field>

            <Errors f="comments" {...props} />
          </div>
          <div className="contactFormButton">
            {/* <span className="requiredNote" style={{ float: "left" }}>
              * required fields
            </span> */}
            <button
              type="button"
              className="resetButton bk-button"
              onClick={handleReset}
              disabled={!dirty || isSubmitting}
            >
              Reset
            </button>
            <button
              type="submit"
              className="contactButton bk-button"
              disabled={isSubmitting}
            >
              Submit
            </button>
          </div>
          {isSubmitting && <AbsoluteLoadingOverlay />}
        </form>
      )}
    </div>
  );
};

const postData = (url, data) => {
  // Default options are marked with *
  return fetch(url, {
    body: JSON.stringify(data), // must match 'Content-Type' header
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    //credentials: 'same-origin', // include, same-origin, *omit
    headers: {
      "content-type": "application/json",
    },
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, cors, *same-origin
    redirect: "follow", // *manual, follow, error
    referrer: "no-referrer", // *client, no-referrer
  }).then((response) => response.json());
};

const EnhancedForm = withFormik({
  mapPropsToValues: (props) => {
    return {
      name: "",
      company_name: "",
      company_address: "",
      referral_company_name: "",
      referral_contact_name: "",
      referral_contact_email: "",
      referral_contact_phone: "",
      comments: "",
    };
  },
  /* Building a Yup schema with a cyclic dependency and the noSortEdges "escape hatch" worked in Chrome, but somehow blew up in IE.
    I tried to figure it out, but eventually had to give up and write a simple custom validation.
     */
  validate: (values, props) => {
    let errors = {};

    // copied from yup https://raw.githubusercontent.com/jquense/yup/cd407f53cadd2c94fab55c3c2d536245ac7c7919/src/string.js
    const rEmail =
      /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-line

    // Really basic 10-digit validation
    const rPhone = /^\D*\d{3}\D*\d{3}\D*\d{4}\D*$/;

    if (!values.name) {
      errors.name = "Please enter your name";
    }
    if (!values.referral_contact_name) {
      errors.referral_contact_name = "Please enter referral contact name";
    }

    // if (!values.company_name) {
    //   errors.company_name = "Please enter your company's name";
    // }
    // if (!values.company_address) {
    //   errors.company_address = "Please enter your company's address";
    // }

    if (
      values.referral_contact_email &&
      !rEmail.test(values.referral_contact_email)
    ) {
      errors.referral_contact_email = "Invalid email address";
    }
    if (
      values.referral_contact_phone &&
      !rPhone.test(values.referral_contact_phone)
    ) {
      errors.referral_contact_phone = "Invalid phone number";
    }
    if (!values.referral_contact_email && !values.referral_contact_phone) {
      errors.referral_contact_email =
        "Please enter either the referral contact's email address or phone number";
      errors.referral_contact_phone =
        "Please enter either the referral contact's email address or phone number";
    }

    return errors;
  },

  handleSubmit: (values, { props, setSubmitting }) => {
    const payload = {
      ...values,
    };
    postData(`${API_BASE_API}tenantReferralForm`, payload)
      .then((data) => {
        props.captureResult(data.msg);
        setSubmitting(false);
        //        props.closeModal && props.closeModal();
      })
      .catch((error) => {
        console.error(error);
        sendError(error);
        props.captureResult("An error has occurred. Please try again later.");
        setSubmitting(false);
      });
  },
  displayName: "TenantReferralForm", // helps with React DevTools
})(TenantReferralForm);

const TenantReferralFormWrapper = (props) => {
  const [submissionResult, setSubmissionResult] = useState();
  return (
    // <div style={{ display: "flex", justifyContent: "space-between" }}>

    <div className="col-lg-12 col-sm-6">
      <EnhancedForm
        {...props}
        captureResult={setSubmissionResult}
        submissionResult={submissionResult}
      />
    </div>
    // </div>
  );
};

const TenantReferralFormButton = WithModal(({ ...props }) => (
  <div>
    <button
      className="contactButton bk-button"
      onClick={props.showModal}
      style={{ fontSize: "12px" }}
    >
      Click Here
    </button>
    {props.modalContent(<TenantReferralFormWrapper {...props} />, {
      showCloseIcon: true,
      trackPath: `tenantreferral`,
      modalStyles: { width: "1200px" },
      closeOnOverlayClick: false,
    })}
  </div>
));

export default TenantReferralFormButton;
